import classNames from 'classnames'
import React from 'react'

import './Loader.scss'

export interface LoaderProps {
	isActive?: boolean
}

export function Loader(props: LoaderProps) {
	const className = classNames('loader-wrapper', props.isActive && 'is-active')

	return (
		<div className={className}>
			<div className="loader is-loading"></div>
		</div>
	)
}